module.exports = __webpack_public_path__ + "media/bootstrap-icons/arrow-left-ef02da42.svg";